import React, { useRef, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Input, InputAdornment, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { CalendarIcon } from '../icons';
import PopoverStyles from '../styles/popover';

const useStyles = makeStyles(() => ({
  calendar: {
    fontSize: '0.75rem',
    width: '5.688rem',
    color: 'white',
    cursor: 'default',

    '& input': {
      cursor: 'default',
    },
  },
  icon: {
    cursor: 'pointer',
  },
}));

const Calendar = ({
  value,
  onChange,
  handleOpen,
  handleClose,
  handleOnLoad,
  ...rest
}) => {
  const styles = useStyles();
  const boxRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    open && handleOnLoad && handleOnLoad();
  }, [open, handleOnLoad]);

  const onDateChange = useCallback(
    (date) => {
      !date.isSame(value) && onChange(date);
    },
    [onChange, value]
  );

  const handleOnClick = useCallback(() => {
    setOpen(!open);
    handleOpen && handleOpen();
  }, [handleOpen, open]);

  const handleOnClose = useCallback(() => {
    setOpen(false);
    handleClose && handleClose();
  }, [handleClose]);

  return (
    <Box ref={boxRef}>
      {
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            value={value}
            onChange={onDateChange}
            onClose={handleOnClose}
            open={open}
            views={['year', 'month', 'day']}
            inputFormat="DD/MM/YYYY"
            PopperProps={{
              ...PopoverStyles,
              anchorEl: boxRef.current,
            }}
            renderInput={(params) => (
              <Input
                {...params}
                inputProps={{
                  ...params.inputProps,
                  'data-testid': 'calendar-input-value',
                }}
                disableUnderline
                className={styles.calendar}
                endAdornment={
                  <InputAdornment
                    className={styles.icon}
                    position="end"
                    data-testid="calendar-icon"
                    onClick={handleOnClick}
                  >
                    <CalendarIcon />
                  </InputAdornment>
                }
              />
            )}
            {...rest}
          />
        </LocalizationProvider>
      }
    </Box>
  );
};

Calendar.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default Calendar;
